export class OpenDialog {
  static readonly type = '[Error dialog] Open dialog';

  constructor(public url: string, public content: string) { }
}

export class CloseDialog {
  static readonly type = '[Error dialog] Close dialog';
}

export class OpenUrl {
  static readonly type = '[Error dialog] Open url';
}
